import { render, staticRenderFns } from "./Addport.vue?vue&type=template&id=13d9d274&scoped=true&"
import script from "./Addport.vue?vue&type=script&lang=js&"
export * from "./Addport.vue?vue&type=script&lang=js&"
import style0 from "./Addport.vue?vue&type=style&index=0&id=13d9d274&lang=scss&scoped=true&"
import style1 from "./Addport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d9d274",
  null
  
)

export default component.exports